import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/config';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/certificate-admin';

  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    // @ işareti varsa kaldır
    const cleanValue = value.replace('@', '').replace('nqcagency.com', '').trim();
    setUsername(cleanValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!auth) {
      setError('Firebase Authentication is not initialized. Please check your Firebase configuration. Make sure .env file exists and npm start was restarted.');
      setLoading(false);
      return;
    }

    try {
      // Username'e @nqcagency.com ekle
      const email = username.trim() + '@nqcagency.com';
      console.log('Attempting login with email:', email);
      console.log('Auth object:', auth);
      console.log('Auth app:', auth?.app);
      
      await signInWithEmailAndPassword(auth, email, password);
      console.log('Login successful!');
      // Login başarılı, yönlendir
      navigate(from, { replace: true });
    } catch (err) {
      console.error('Login error details:', {
        code: err.code,
        message: err.message,
        email: username.trim() + '@nqcagency.com'
      });
      
      let errorMessage = 'Login failed. Please check your credentials.';
      
      if (err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
        errorMessage = 'Invalid username or password. Please check your credentials.';
      } else if (err.code === 'auth/wrong-password') {
        errorMessage = 'Incorrect password. Please try again.';
      } else if (err.code === 'auth/invalid-email') {
        errorMessage = 'Invalid username.';
      } else if (err.code === 'auth/too-many-requests') {
        errorMessage = 'Too many failed attempts. Please try again later.';
      } else if (err.code === 'auth/network-request-failed') {
        errorMessage = 'Network error. Please check your internet connection and Firebase configuration.';
      } else if (err.code === 'auth/invalid-api-key') {
        errorMessage = 'Invalid Firebase API key. Please check your .env file configuration.';
      } else if (err.code === 'auth/operation-not-allowed') {
        errorMessage = 'Email/Password sign-in is not enabled. Please enable it in Firebase Console (Authentication > Sign-in method > Email/Password).';
      } else {
        errorMessage = `Login failed: ${err.message || err.code || 'Unknown error'}`;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-header">
          <h1 className="login-title">Admin Login</h1>
          <p className="login-subtitle">Nova Quality Certification Agency</p>
        </div>

        {error && (
          <div className="login-alert login-alert-error">
            <strong>✗ Error:</strong> {error}
            <div style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}>
              <p style={{ margin: '5px 0' }}>Troubleshooting:</p>
              <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                <li>Check browser console (F12) for detailed error messages</li>
                <li>Verify Firebase Authentication is enabled in Firebase Console</li>
                <li>Verify Email/Password sign-in method is enabled</li>
                <li>Verify the user exists in Firebase Console (Authentication &gt; Users)</li>
                <li>Check .env file has correct Firebase config values</li>
                <li>Make sure you restarted npm start after creating .env file</li>
              </ul>
            </div>
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username
            </label>
            <div className="username-input-wrapper">
              <input
                type="text"
                id="username"
                name="username"
                className="form-input username-input"
                value={username}
                onChange={handleUsernameChange}
                placeholder="admin"
                required
                disabled={loading}
                autoComplete="username"
              />
              <span className="username-suffix">@nqcagency.com</span>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <a href="/" className="login-link">Back to Home</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;

